const templateRequests = new Map<string, Promise<string>>()

export function loadAgreementTemplate(url: string): Promise<string> {
  const normalizedUrl = url.trim()
  if (!normalizedUrl) {
    return Promise.reject(new Error("Agreement template URL is required"))
  }

  try {
    new URL(normalizedUrl, window.location.href)
  } catch {
    return Promise.reject(new Error(`Invalid agreement template URL: ${normalizedUrl}`))
  }

  const cached = templateRequests.get(normalizedUrl)
  if (cached) return cached

  const request = fetch(normalizedUrl).then(async (response) => {
    if (!response.ok) {
      throw new Error(`Failed to load agreement template ${normalizedUrl}: HTTP ${response.status}`)
    }
    return response.text()
  })

  templateRequests.set(normalizedUrl, request)
  void request.catch(() => {
    if (templateRequests.get(normalizedUrl) === request) {
      templateRequests.delete(normalizedUrl)
    }
  })

  return request
}
